import amplitude from 'amplitude-js';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { createStructuredSelector } from 'reselect';
import { get, isUndefined, isNull } from 'lodash';
import styled from 'styled-components';
import {
  AmplitudeProvider,
  Amplitude,
  LogOnMount,
} from '@amplitude/react-amplitude';
import NavigationBar from '@components/NavigationBar/NavigationBar';
import { userDataSelector, appKeysSelector } from '@selectors/global';
import '@assets/theme/index.scss';
import DeploymentWatch from './components/DeploymentWatch/DeploymentWatch';
import { SUBSCRIPTION_TYPES } from '../../constants';
import { FullStoryIntegration } from '../../fullstory';

class App extends Component {
  render() {
    const { children, userData, appKeys } = this.props;

    const AMPLITUDE_KEY = appKeys.get('amplitude');
    const FULLSTORY_ORG_ID = appKeys.get('fullstory');
    const dotNumber = get(userData, 'claims.carrier_dot_number', null);
    const carrierName = get(userData, 'claims.carrier_name', null);
    const firstName = get(userData, 'claims.user_first_name', null);
    const lastName = get(userData, 'claims.user_last_name', null);
    const emailAddr = get(userData, 'claims.user_email', null);
    const userId = get(userData, 'claims.user_id', null);
    const subscriptionTypeNonDenormalized = get(
      userData,
      'claims.subscription_type',
    );

    const subscriptionType =
      !isNull(subscriptionTypeNonDenormalized) &&
      !isUndefined(subscriptionTypeNonDenormalized)
        ? get(SUBSCRIPTION_TYPES, subscriptionTypeNonDenormalized)
        : subscriptionTypeNonDenormalized;
    var appLoadEventName = 'appLoad';
    var instance = amplitude.getInstance();
    instance.init(AMPLITUDE_KEY, userId, {
      saveEvents: true,
      includeUtm: true,
      includeReferrer: true,
    });
    return (
      <App.Container>
        <AmplitudeProvider
          amplitudeInstance={instance}
          apiKey={AMPLITUDE_KEY}
          userId={userId}
        >
          <Amplitude
            userProperties={{
              carrier_name: carrierName,
              dot_number: dotNumber,
              email: emailAddr,
              subscriptionType,
            }}
          >
            <FullStoryIntegration
              props={userData}
              orgId={FULLSTORY_ORG_ID}
              userId={userId || 0}
              dotNumber={dotNumber}
              carrierName={carrierName}
              emailAddr={emailAddr}
              firstName={firstName}
              lastName={lastName}
            />
            <LogOnMount eventType={appLoadEventName} />
            <DeploymentWatch />
            <NavigationBar />
            {children}
          </Amplitude>
        </AmplitudeProvider>
      </App.Container>
    );
  }
}

App.propTypes = {
  userData: PropTypes.object,
  appKeys: ImmutablePropTypes.map,
  children: PropTypes.node.isRequired,
};

App.Container = styled.div`
  width: fit-content;
  min-width: 100%;
`;

const mapStateToProps = createStructuredSelector({
  userData: userDataSelector,
  appKeys: appKeysSelector,
});

const enhance = compose(connect(mapStateToProps));

export default enhance(App);
